import { motion } from "framer-motion";

export const Nav = () => (
  <motion.header
    data-testid="nav-header"
    initial={{ y: -60, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
    className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#030305]/70 border-b border-white/10"
  >
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center justify-between">
      <a href="/" data-testid="nav-logo" className="font-display font-extrabold text-lg tracking-[0.25em] uppercase">
        Zavico<span className="text-[#00f0ff]">.</span>
      </a>
      <div className="flex items-center gap-3 text-xs font-mono-z uppercase tracking-[0.3em] text-[#8e8ea0]">
        <span className="w-1.5 h-1.5 rounded-full bg-[#00f0ff] pulse-dot" />
        <span data-testid="nav-status" className="hidden sm:inline">Signal Detected</span>
        <span className="sm:hidden">Live</span>
      </div>
    </div>
  </motion.header>
);

export default Nav;
